var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecoverIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.002,
    viewBox: "0 0 22 22.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -9.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.668,19.525a1.524,1.524,0,0,1,1.455,1.587v3.7A1.526,1.526,0,0,1,23.668,26.4H18.334a1.524,1.524,0,0,1-1.455-1.587v-3.7a1.526,1.526,0,0,1,1.455-1.587h5.333Zm-2.68,1.38a1.347,1.347,0,0,0-1.376,1.315,1.329,1.329,0,0,0,.786,1.084v1.708h1.178V23.305a1.328,1.328,0,0,0,.786-1.084A1.342,1.342,0,0,0,20.988,20.906ZM21,16.778a1.284,1.284,0,0,0-1.376,1.376v1.371H18.24V18.286s0-2.887,2.754-2.887,2.754,2.887,2.754,2.887v1.239H22.375V18.154A1.287,1.287,0,0,0,21,16.778ZM21,31.9a11,11,0,1,1,5.387-20.586L27.41,9.9l1.832,4.815-4.8-.7,1.134-1.569a9.616,9.616,0,1,0,4.328,4.8l1.27-.523A10.992,10.992,0,0,1,21,31.9Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverIcon);
export default __webpack_public_path__ + "static/media/recover_icon.e5a769fff9e4d0eb1c541fb75ea76e30.svg";
export { ForwardRef as ReactComponent };